<div>
  <div class="px-3 py-2 bg-[#0F11144D] bg-opacity-30 rounded-lg space-y-2">
    @if (displayedActions().added.length > 0) {
      <div class="pb-2 border-b border-neutral-700">
        <h2 class="text-xs font-bold text-green-300 leading-6">
          Task to be added (<span>{{ selectedActions().added.size }}</span
          >):
        </h2>
        <div class="space-y-2">
          @for (action of displayedActions().added; track action.id; let i = $index) {
            <div
              [ngClass]="{ 'bg-[#FFFFFF0D] bg-opacity-5': i % 2 === 1 }"
              class="flex items-start px-0.5 rounded"
            >
              <input
                [checked]="isSelected('added', action.id)"
                (change)="toggleAction('added', action.id)"
                class="mt-1 mr-1 h-4 w-4 text-blue-600 rounded cursor-pointer"
                type="checkbox"
              />
              <div>
                <span class="font-medium text-xs text-neutral-50 leading-5">{{
                  action.displayTitle
                }}</span>
                <p class="text-2xs text-neutral-200 mt-1 leading-4">{{ action.description }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (displayedActions().deleted.length > 0) {
      <div class="pb-2 border-b border-neutral-700">
        <h2 class="text-xs font-bold text-red-300 leading-6">
          Task to be removed (<span>{{ selectedActions().deleted.size }}</span
          >):
        </h2>
        <div class="space-y-2">
          @for (action of displayedActions().deleted; track action.id; let i = $index) {
            <div
              [ngClass]="{ 'bg-[#FFFFFF0D] bg-opacity-5': i % 2 === 1 }"
              class="flex items-start px-0.5 rounded"
            >
              <input
                [checked]="isSelected('deleted', action.id)"
                (change)="toggleAction('deleted', action.id)"
                class="mt-1 mr-1 h-4 w-4 text-blue-600 rounded cursor-pointer"
                type="checkbox"
              />
              <div>
                <span class="font-medium text-xs text-neutral-50 leading-5">{{
                  action.displayTitle
                }}</span>
                <p class="text-2xs text-neutral-200 mt-1 leading-4">{{ action.description }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    }
    @if (displayedActions().updated.length > 0) {
      <div class="pb-2">
        <h2 class="text-xs font-bold text-yellow-500 leading-6">
          Task to be modified (<span>{{ selectedActions().updated.size }}</span
          >):
        </h2>
        <div class="space-y-2">
          @for (action of displayedActions().updated; track action.id; let i = $index) {
            <div
              [ngClass]="{ 'bg-[#FFFFFF0D] bg-opacity-5': i % 2 === 1 }"
              class="flex items-start px-0.5 rounded"
            >
              <input
                [checked]="isSelected('updated', action.id)"
                (change)="toggleAction('updated', action.id)"
                class="mt-1 mr-1 h-4 w-4 text-blue-600 rounded cursor-pointer"
                type="checkbox"
              />
              <div>
                <span class="font-medium text-xs text-neutral-50 leading-5">{{
                  action.displayTitle
                }}</span>
                <p class="text-2xs text-neutral-200 mt-1 leading-4">{{ action.description }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="flex gap-2 mt-3">
    <flx-ai-action-button
      (clicked)="keepExecutionPlanUpdates()"
      label="Update Plan"
      flavor="accept"
      iconName="actions-keep"
      data-testid="ai-update-plan-button"
    />
    <flx-ai-action-button
      (clicked)="discardExecutionPlanUpdate()"
      label="Don't Update"
      flavor="discard"
      iconName="actions-delete"
      data-testid="ai-dont-update-button"
    />
  </div>
</div>
